import { cn } from '@/lib/utils'

type GreenBorderGradientProps = {
  className?: string
}

const GreenBorderGradient = ({ className }: GreenBorderGradientProps) => {
  return (
    <div
      className={cn('pointer-events-none absolute inset-0', className)}
      style={{
        background: `radial-gradient(104.11% 146.87% at 3.42% -31.25%, rgba(168, 255, 213, 0.8) 0%, rgba(189, 255, 223, 0) 100%)`,
        mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        maskComposite: 'exclude',
        padding: '1px',
      }}
    />
  )
}

export default GreenBorderGradient
